import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20
    },
    wrapRtp: {
        padding: '10px 0', 
        marginBottom: 12, 
        width: '100%', 
        background: '#1b2039', 
        borderRadius: 8, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        flexDirection: 'column'
    },
    wrapList: {
        marginBottom: 12, 
        width: '100%', 
        background: '#1b2039', 
        borderRadius: 8, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        flexDirection: 'column'
    }
}))

export {
    useStyles
}